import { render } from "./userManage.vue?vue&type=template&id=64affd79&scoped=true"
import script from "./userManage.vue?vue&type=script&lang=js"
export * from "./userManage.vue?vue&type=script&lang=js"

import "./userManage.vue?vue&type=style&index=0&id=64affd79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64affd79"]])

export default __exports__